import { render, staticRenderFns } from "./ExamDocumentModal.vue?vue&type=template&id=d4c5510e"
import script from "./ExamDocumentModal.vue?vue&type=script&lang=ts"
export * from "./ExamDocumentModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports